<template>
  <div>
    <div class="graph_frame_full" style="height: 320px">
      <div class="chart_paragraph_full">RÉPARTITION DES REMBOURSEMENTS</div>
      <div style="display: flex; justify-content: space-between">
        <!-- <StackedBar
          v-if="chart.block_1"
          :graph_data="json_data_advanced.reimb_rep_actes"
          :timestamp="timestamp"
          translate_key="actes"
          :event_name="'updateData_sb'"
        /> -->
        <StackedBarPercentRemb
          v-if="chart.block_1"
          :key="'reimb_rep_actes'"
          :graph_data="json_data_advanced.reimb_rep_actes"
          :timestamp="timestamp"
          :event_name="'updateData_sb'"
          :translate_key="'actes'"
        />
      </div>
    </div>
    <div class="graph_frame_full" style="height: 360px">
      <div class="chart_paragraph_full">REMBOURSEMENT CPMS PAR GRAND POSTE</div>
      <div style="display: flex; justify-content: space-between">
        <DoublePie
          v-if="chart.block_2"
          :graph_data="json_data_advanced.actes"
          :graph_sub_data="json_data_advanced.actes_subactes"
          :timestamp="timestamp"
          :translate_key="'actes'"
          :translate_sub_key="'actes_sub'"
        />
      </div>
    </div>
    <div class="graph_frame_full height_300">
      <div class="chart_paragraph_full">
        CADENCE MENSUELLE DES REMBOURSEMENTS CPMS
      </div>
      <div style="display: flex; justify-content: space-between">
        <DateDataBar
          v-if="chart.block_3"
          :graph_data="json_data_advanced.reimb_bymonth_p"
          :year="json_data_advanced.year"
          :timestamp="timestamp"
          :action="action"
        />
      </div>
    </div>

    <div style="display: flex; justify-content: space-between">
      <div class="graph_frame" style="width: 520px; height: 260px">
        <div class="chart_paragraph_full">
          REMBOURSEMENT CPMS PAR TYPE DE PERSONNE
        </div>
        <div style="display: flex; justify-content: space-between">
          <Pie
            v-if="chart.block_4"
            :graph_data="json_data_advanced.types"
            :timestamp="timestamp"
            :event_name="'updateData_pm_1'"
            :translate_key="'family'"
          />
        </div>
      </div>
      <div class="graph_frame" style="width: 560px; height: 260px">
        <div class="chart_paragraph_full" style="height: 56px">
          REPARTITION DES REMBOURSEMENTS CPMS PAR GRAND POSTE ET PAR TYPE DE
          PERSONNE
        </div>
        <div style="display: flex; justify-content: space-between">
          <StackedBarPercent
            v-if="chart.block_4"
            :key="'family'"
            :graph_data="json_data_advanced.types_actes"
            :timestamp="timestamp"
            :event_name="'updateData_sbp_1'"
            :translate_key="'family'"
          />
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: space-between">
      <div class="graph_frame" style="width: 520px; height: 260px">
        <div class="chart_paragraph_full">
          REMBOURSEMENT CPMS PAR {{ sousCategory }} CATEGORIE
        </div>
        <div style="display: flex; justify-content: space-between">
          <Pie
            v-if="chart.block_5"
            :graph_data="json_data_advanced.categories"
            :timestamp="timestamp"
            :event_name="'updateData_pm_2'"
            :translate_key="'category'"
            :category="category"
          />
        </div>
      </div>
      <div class="graph_frame" style="width: 560px; height: 260px">
        <div class="chart_paragraph_full" style="height: 56px">
          REPARTITION DES REMBOURSEMENTS CPMS PAR GRAND POSTE ET PAR TYPE DE
          {{ sousCategory }} CATEGORIE
        </div>
        <div style="display: flex; justify-content: space-between">
          <StackedBarPercent
            v-if="chart.block_5 && category === 'all'"
            :key="'category'"
            :graph_data="json_data_advanced.categories_actes"
            :timestamp="timestamp"
            :event_name="'all_categories____'"
            :translate_key="'category'"
            :category="category"
          />
          <StackedBarPercent
            v-if="chart.block_5 && category === 'ac'"
            :key="'category'"
            :graph_data="json_data_advanced.categories_actes"
            :timestamp="timestamp"
            :event_name="'all_Ac'"
            :translate_key="'category'"
            :category="category"
          />
          <StackedBarPercent
            v-if="chart.block_5 && category === 'in'"
            :key="'category'"
            :graph_data="json_data_advanced.categories_actes"
            :timestamp="timestamp"
            :event_name="'all_In'"
            :translate_key="'category'"
            :category="category"
          />
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: space-between">
      <div class="graph_frame" style="width: 520px; height: 260px">
        <div class="chart_paragraph_full">REMBOURSEMENT CPMS PAR COLLEGE</div>
        <div style="display: flex; justify-content: space-between">
          <Pie
            v-if="chart.block_6"
            :graph_data="json_data_advanced.colleges"
            :timestamp="timestamp"
            :event_name="'updateData_pm_3'"
            :translate_key="'college'"
          />
        </div>
      </div>
      <div class="graph_frame" style="width: 560px; height: 260px">
        <div class="chart_paragraph_full" style="height: 56px">
          REPARTITION DES REMBOURSEMENTS CPMS PAR GRAND POSTE ET PAR TYPE DE
          COLLEGE
        </div>
        <div style="display: flex; justify-content: space-between">
          <StackedBarPercent
            v-if="chart.block_6"
            :key="'college'"
            :graph_data="json_data_advanced.colleges_actes"
            :timestamp="timestamp"
            :event_name="'updateData_sbp_3'"
            :translate_key="'college'"
          />
        </div>
      </div>
    </div>
    <a-divider></a-divider>
  </div>
</template>

<script>
import StackedBar from "./StackedBar.vue";
import DoublePie from "./DoublePie.vue";
import DateDataBar from "./DateDataBar.vue";
import StackedBarPercent from "./StackedBarPercent.vue";
import StackedBarPercentRemb from "./StackedBarPercentRemb.vue";
import PieMoney from "./PieMoney.vue";
import Pie from "./Pie.vue";
import Loading from "../Loading.vue";

export default {
  components: {
    StackedBar,
    DoublePie,
    DateDataBar,
    StackedBarPercent,
    StackedBarPercentRemb,
    PieMoney,
    Pie,
    Loading,
  },
  props: {
    timestamp: {
      type: Number,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    json_data_advanced: {
      type: Object,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      chart: {
        block_1: false,
        block_2: false,
        block_3: false,
        block_4: false,
        block_5: false,
        block_6: false,
      },
    };
  },
  computed: {
    categoryEventName() {
      return "jshfsjfhskjfhskjd";
    },
    sousCategory() {
      return this.category === "all" ? "" : "SOUS";
    },
  },
  mounted() {
    Object.keys(this.chart).forEach((key, i) => {
      setTimeout(() => {
        this.chart[key] = true;
      }, i * 1000);
    });
  },
};
</script>

<style scoped>
.graph_frame {
  position: relative;
  background-color: white;
  margin-bottom: 22px;
  border-radius: 10px;
  box-shadow: 0 0 3px 0 #ccc;
  width: 538px;
}
.graph_frame_full {
  position: relative;
  background-color: white;
  margin-bottom: 22px;
  border-radius: 10px;
  box-shadow: 0 0 3px 0 #ccc;
  width: 100%;
}
.height_300 {
  height: 300px;
}
#repartion_de_remboursement {
  width: 100%;
  height: 320px;
}
#remboursement_cpms_par_grand_poste {
  width: 100%;
  height: 860px;
}
.chart_paragraph {
  width: 510px;
  height: 60px;
  border-bottom: 1px solid #f1f1f1;
  padding: 10px 16px;
  font-weight: bold;
  color: darkslategray;
  vertical-align: middle;
}
.chart_paragraph_full {
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #f1f1f1;
  padding: 10px 16px;
  font-weight: bold;
  color: darkslategray;
  vertical-align: middle;
  font-size: 13px;
}
.chart_list {
  width: 274px;
  padding-top: 24px;
}
</style>